import React from 'react';

function HOCSidePanel({ openSidePanel, render }) {
  return (
    <div className={`overlay-sidepanel ${openSidePanel ? 'open' : ''}`}>
    <div className={`sliding-side-panel ${openSidePanel ? 'open' : ''}`}>
      <div className="panel-content h-full w-full">
        {openSidePanel && (
          <>
            {render()}
          </>
        )}
      </div>
    </div>
    </div>
  );
}

export default HOCSidePanel;
